import React, { useState } from 'react';
import { Button, useTranslate, useRefresh } from 'react-admin';
import SuspectForm from './form';
import {
  Edit as IconContentEdit,
  Close as CloseIcon,
} from '@material-ui/icons';
import { Dialog, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { linkButton } from 'styles';

const resource = 'eventSuspect';

const SuspectQuickEditButton = ({ record, permissions }) => {
  const [showDialog, setShowDialog] = useState(false);
  const translate = useTranslate();
  const refresh = useRefresh();
  const buttonClasses = linkButton();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Button
        className={buttonClasses.root}
        onClick={handleClick}
        label="ra.action.edit"
      >
        <IconContentEdit />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={`Edit ${resource}`}
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {translate(`resources.${resource}.titles.edit`)}
            <IconButton aria-label="close" onClick={handleCloseClick}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <SuspectForm
          record={record}
          resource={resource}
          onSuccess={(data) => {
            setShowDialog(false);
            refresh();
          }}
        />
      </Dialog>
    </>
  );
};

export default SuspectQuickEditButton;
